import React from "react";
import { Image } from "@heroui/image";

import { About2 } from "@/public/assets";

const WhoAreWe = () => {
  return (
    <section className="lg:px-28 px-6 pt-14 lg:pt-20 max-w-screen-2xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div data-aos="fade-right" data-aos-duration="1000">
          <div className="text-primary text-sm font-medium leading-4 mb-4">
            Who we are
          </div>

          <div
            className="
              text-base
              sm:text-lg
              font-medium
              leading-7
              lg:leading-6
              tracking-[-0.27px]
              max-w-2xl
            "
          >
            We are a recruitment partner focused on helping businesses identify,
            <br className="hidden lg:block" />
            assess, and place the right talent across different roles and
            industries.
          </div>
        </div>

        <div
          className="
            shadow-[10px_10px_0_0_var(--neutral-950,#0E121B)]
            lg:shadow-[16px_16px_0_0_var(--neutral-950,#0E121B)]
            dark:shadow-[10px_10px_0_0_var(--neutral-100,#F5F7FA)]
            lg:dark:shadow-[16px_16px_0_0_var(--neutral-100,#F5F7FA)]
            rounded-[24px]
            overflow-hidden
          "
          data-aos="zoom-in"
          data-aos-delay="200"
          data-aos-duration="1000"
        >
          <Image
            removeWrapper
            alt="img 43"
            className="
              object-cover
              rounded-[24px]
              w-full
              h-[260px]
              sm:h-[360px]
              lg:h-auto
            "
            src={About2.src}
          />
        </div>
      </div>
    </section>
  );
};

export default WhoAreWe;
